class SkuTutor {
  id = null;
  name = null;
  status = null;
  code = null;
  orgPrice = null;
  subjectId = null;
  level = null; // curriculumTypes
  transactionStatus = null;
  // type = 'duo';
  curriculumId = null; // Tutor
  learningPathIds = []; // Tutor
  lmsCodes = [];
  classTypeId = null; // Tutor
  teacherTypeId = null; // Tutor
  numOfLesson = null; // Tutor
  cardDisplayName = null; // Tutor

  constructor(data) {
      this.id = data.id ?? null;
      this.code = data.code ?? null;
      this.name = data.name ?? null;
      this.status = data.status ?? null;
      this.orgPrice = data.orgPrice ?? null;
      this.subjectId = data.subjectId ?? null;
      this.level = data.level ?? null;
      this.transactionStatus = data.transactionStatus ?? null;
      this.curriculumId = data.curriculumId ?? null;
      this.classTypeId = data.classTypeId ?? null;
      this.teacherTypeId = data.teacherTypeId ?? null;
      this.numOfLesson = data.numOfLesson ?? null;
      this.cardDisplayName = data.cardDisplayName ?? null;
      this.learningPathIds = data.learningPathIds ?? [];
      this.lmsCodes = data.lmsCodes ?? [];
      this.monthsValid = data.monthsValid ?? null;
      // this.type =  'duo';
  }
}

export default SkuTutor;